import { MemberMutationResponse, NewMember } from '~/api/types';
import { v2Api } from '../v2Api';

const tags = ['member', 'project'] as const;

const memberApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getNewMembers: builder.query<NewMember[], { projectId?: number }>({
        query: ({ projectId }) => `projects/${projectId}/members/selection`,
        transformResponse: (response: { data: NewMember[] }) => response.data,
        providesTags: tags,
      }),
      addMember: builder.mutation<MemberMutationResponse, { role_id: number; user_id: string; projectId: number }>({
        query: ({ projectId, ...body }) => {
          return {
            url: `projects/${projectId}/members/project-role`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: tags,
      }),
      removeMember: builder.mutation<MemberMutationResponse, { user_id: string; projectId: number }>({
        query: ({ projectId, ...body }) => {
          return {
            url: `projects/${projectId}/members/project-role`,
            method: 'DELETE',
            body,
          };
        },
        invalidatesTags: tags,
      }),
      changeMemberRole: builder.mutation<object, { user_id: string; projectId: number; role_id: number }>({
        query: ({ projectId, ...body }) => {
          return {
            url: `projects/${projectId}/members/project-role`,
            method: 'PUT',
            body,
          };
        },
        invalidatesTags: tags,
      }),
      transferOwnership: builder.mutation<object, { user_id: string; projectId: number }>({
        query: ({ projectId, ...body }) => {
          return {
            url: `projects/${projectId}/members/project-role/transfer-ownership`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: tags,
      }),
    }),
  });

export default memberApi;
